import { v4 as uuid } from 'uuid';

export default class QuestionModel {
    constructor(index, newUuid) {
        this.order = index;
        this.id = undefined;
        this.question = '';
        this.answerOptions = [];
        this.coinsToEarn = 0;
        this.uuid = newUuid ? newUuid : uuid();
    }
    static copy(from, to) {
        return QuestionModel.assingQuestions(from, to);
    }
    static copyAnswerOptions(from, to) {
        return QuestionModel.answerOptions(from, to);
    }
    static answerOptions(from, to) {
        to = [];
        if (!from) {
            return to;
        }
        from.forEach((f, index) => {
            const newTo = f;
            newTo.order = f.order;
            newTo.uuid = f.id;
            to.push(newTo);
        });
        return to;
    }
    static assingQuestions(questionsFrom, questionsTo) {
        questionsTo = [];

        if (!questionsFrom) {
            return questionsTo;
        }
        questionsFrom.forEach((questionFrom, index) => {
            const currentQuestionTo = new QuestionModel(index, questionFrom.id);
            QuestionModel.assign(questionFrom, currentQuestionTo, index);
            questionsTo.push(currentQuestionTo);
        });
        return questionsTo;
    }
    static assign(from, to, index) {
        if (from) {
            to.id = from.id;
            to.order = from.order;
            to.question = from.question ? from.question : '';
            to.answerOptions = from.answerOptions ? QuestionModel.answerOptions(from.answerOptions) : undefined;
            to.coinsToEarn = from.coinsToEarn;
            to.headerPhoto = from.headerPhoto;
        } else {
            to = new QuestionModel(index);
        }
    }
}
